import { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Modal, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";

const ScanOutboundManifest = ({
    show,
    handleClose,
    reduxFetchTransferForInboundByManifest,
    successfulFetchTransferForInboundByManifest,
    errorsFetchTransferForInboundByManifest,
    reduxResetTransferForInboundByManifestForm,
}) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        clearErrors,
        setError,
    } = useForm({
        defaultValues: {
            outboundManifestCode: '',
        }
    });

    const outboundManifestCodeRef = useRef(null);

    const {ref, ...outboundManifestCodeRegister} = register("outboundManifestCode", {
        required: "Este campo es requerido",
    });

    useEffect(() => {
        if (!show) return;

        reduxResetTransferForInboundByManifestForm();
        outboundManifestCodeRef.current.focus();
    }, [show]);

    useEffect(() => {
        if (!show) return;

        if (successfulFetchTransferForInboundByManifest === true) {
            closeModal();
        }

        if (errorsFetchTransferForInboundByManifest === true) {
            setError('outboundManifestCode', { type: 'custom', message: `Manifiesto no válido` });
            outboundManifestCodeRef.current.focus();
        }
    }, [show, successfulFetchTransferForInboundByManifest, errorsFetchTransferForInboundByManifest])

    const closeModal = () => {
        handleClose();
    }

    const searchOrder = (data) => {
        clearErrors('outboundManifestCode');

        const idManifest = data.outboundManifestCode.split('-')[0];

        reduxFetchTransferForInboundByManifest({
            idManifest: idManifest
        })
    }

    return (
        <>
            <Modal
                show={show}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Código de manifiesto de salida
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(searchOrder)}>
                        <div className="form-group">
                            <label className="form-label">
                                Por favor, escanea o digita el manifiesto.
                            </label>
                            <div className="input-group">
                                <Form.Control
                                    {...outboundManifestCodeRegister}
                                    ref={(e) => {
                                        ref(e);
                                        outboundManifestCodeRef.current = e;
                                    }}
                                    type="text"
                                    className={`form-control form-control-user`}
                                />
                                {
                                    errors.outboundManifestCode &&
                                    <span className="error-message">
                                        {errors.outboundManifestCode.message}
                                    </span>
                                }
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        successfulFetchTransferForInboundByManifest: state.wmsTransfersState.successfulFetchTransferForInboundByManifest,
        errorsFetchTransferForInboundByManifest: state.wmsTransfersState.errorsFetchTransferForInboundByManifest,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reduxFetchTransferForInboundByManifest: (payload) =>
            dispatch({
                type: "FETCH_TRANSFER_FOR_INBOUND_BY_MANIFEST_REQUEST",
                value: payload,
            }),
        reduxResetTransferForInboundByManifestForm: () =>
            dispatch({
                type: "RESET_TRANSFER_FOR_INBOUND_BY_MANIFEST_FORM"
            }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScanOutboundManifest);